import { render, staticRenderFns } from "./TeachingVideo.vue?vue&type=template&id=41914fda&scoped=true"
import script from "./TeachingVideo.vue?vue&type=script&lang=js"
export * from "./TeachingVideo.vue?vue&type=script&lang=js"
import style0 from "./TeachingVideo.vue?vue&type=style&index=0&id=41914fda&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41914fda",
  null
  
)

export default component.exports